import styled from '@emotion/styled'
import { Colors } from "../../../../../colors";
import { Grid } from "@mui/material";

export const DetailEventFormStyled = {
  Container: styled.div<any>`
  `,
  ContainerTimeClocks: styled.div<any>`
    margin-bottom: 15px;
  `,
  ContainerDatePicker: styled.div<any>`
    margin-bottom: 40px;
  `,
  ContainerHeaderDetail: styled.div<any>`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  HeaderTitle: styled.span<any>`
    font-family: EncodeSans-Regular;
    font-size: 20px;
    color: ${Colors.Black};
  `,
  ContainerTrash: styled.div<any>`
    &:hover {
      cursor: pointer;
    }
  `,
  ContainerContentTitle:  styled.div<any>`
    display: flex;
    flex-direction: column;
  `,
  TitleSelectedRoom: styled.p<any>`
    font-family: EncodeSans-Regular;
    font-size: 15px;
    color: ${Colors.Black};
  `,
  ContainerTimeClocksFields: styled(Grid) <any>`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  `,
  ContainerStartClock: styled(Grid) <any>`
    margin-bottom: 5px
  `,
  ContainerEndClock: styled(Grid) <any>`
    margin-bottom: 5px
  `,
  BlankSeparator: styled.div<any>`
    margin-bottom: 15px;
  `,
  ContainerLayoutServices: styled.div<any>`
    background-color: ${Colors.LightGrey};
    border-radius: 5px;
    padding: 17px 20px 23px;
  `,
  MaxAttendees: styled.p<any>`
    font-family: EncodeSans-Regular;
    font-size: 10px;
    color: ${Colors.DarkGrey};
    text-align: end;
  `,
  LabelLayoutRoom: styled.div<any>`
    display:flex;
    font-family: EncodeSans-SemiBold;
    font-size: 12px;
    margin-bottom: 10px
  `,
  ContainerRadioButtonsSmartObject: styled.div<any>`
    display: flex;
    flex-direction: column;
  `,
  ContainerButton: styled.div<any>`
    display: flex;
    justify-content: center;
    margin-bottom: 29px;
  `,
  ContainerServices: styled.div<any>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  `,
  ServicesText: styled.p<any>`
    font-family: EncodeSans-Regular;
    font-size: 16px;
  `,
  ContainerServiceButton: styled.div<any>`
  `,
  ContainerSelectedServices: styled.div<any>`
    display: flex; 
    flex-wrap: wrap;
    margin-bottom: 29px;
  `,
  ContainerServiceItem: styled.div<any>`
    margin-top: 11px;
    width: 100%;
  `,
  ContainerContentModal: styled.div<any>`
    background-color: ${Colors.White};
    position: absolute; 
    left: 50%; 
    top: 50%;
    transform: translate(-50%, -50%)
  `,
  ErrorValidation: styled.p<any>`
    color: ${Colors.Red};
    font-family: EncodeSans-Regular;
    font-size: 10px;
    height: 10px;
    margin-top: 3px;
  `,
};
